import React, { CSSProperties, useEffect, useState } from "react";
import { PuffLoader } from "react-spinners";
import styles from "./spinner.module.scss";
import { useSpinner } from "./SpinnerContext";
import MascotLogo from "../../assets/theme/images/mascot-logo.svg";

interface SpinnerProps {
  loading: boolean;
}

const override: CSSProperties = {
  display: "block",
  margin: " 0 auto",
};
const colors = [
  "#8B00FF",
  "#4B0082",
  "#0000FF",
  "#008000",
  "#FFFF00",
  "#FFA500",
  "#FF0000",
];

const Spinner: React.FC = () => {
  const { showSpinner } = useSpinner();
  const [colorIndex, setColorIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setColorIndex((prevIndex) => (prevIndex + 1) % colors.length);
    }, 500); // Change color every 500ms

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={styles.spinnerOverlayWrapper}
      style={{ display: showSpinner ? "block" : "none" }}
    >
      <div className={styles.spinnerContainer}>
        <PuffLoader
          cssOverride={override}
          size={100}
          color={colors[colorIndex]}
          loading={showSpinner}
        />
        <div className={styles.mascotLogo}>
          <img src={MascotLogo} alt="Mascot Logo" className="" />
        </div>
      </div>
    </div>
  );
};

export default Spinner;
